import { ROUTE_NAMES } from '@atlassian/jira-common-constants/src/spa-routes';
import { useRouter, type RouterContext, type RouterDataContext } from '@atlassian/jira-router';

const GLOBAL_APP_ROUTES = [
	// Connect apps
	ROUTE_NAMES.CONNECT_GENERAL,
	ROUTE_NAMES.CONNECT_GENERAL_INVALID, // It seems like some apps may generate invalid urls, but we still have to handle them
	ROUTE_NAMES.LEGACY_CONNECT_GENERAL,
	// Forge apps
	ROUTE_NAMES.FORGE_GLOBAL,
];

export function useIsAppRoute() {
	const [routerContext] = useRouter();
	return isAppRoute(routerContext);
}

export function isAppRoute(routerContext: RouterContext | RouterDataContext) {
	const { route } = routerContext;
	return GLOBAL_APP_ROUTES.some((name) => name === route.name);
}
